import { transactionHubRoutes } from './routes';
import { useTransactionHubStore } from './stores/transaction-hub-store';

export interface ModuleConfig {
  name: string;
  routes: typeof transactionHubRoutes;
  stores: Record<string, unknown>;
  initialize?: () => void;
  cleanup?: () => void;
}

export const TransactionHubModule: ModuleConfig = {
  name: 'transaction-hub',
  routes: transactionHubRoutes,
  stores: {
    transactionHub: useTransactionHubStore,
  },
  initialize: () => {
    console.log('Transaction Hub module initialized');
  },
  cleanup: () => {
    useTransactionHubStore.getState().reset();
    console.log('Transaction Hub module cleaned up');
  },
};

// Re-export types for convenience
export * from './types';

// Re-export hooks
export { useTransactionHub } from './hooks/useTransactionHub';

// Re-export components for use in other modules
export { default as TransactionHub } from './components/TransactionHub';
export { default as TransactionForm } from './components/TransactionForm';
export { default as TransactionResult } from './components/TransactionResult';

export default TransactionHubModule;
